/* istanbul ignore file */
import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const Root = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.rounded.md,
  boxShadow: `inset 0 0 0 0rem ${theme.palette.background.grey.alpha.main}`,
  display: 'flex',
  alignItems: 'center',
  flexBasis: '3rem',
  flexShrink: 0,
  justifyContent: 'center',
  height: '3rem',

  '& img': {
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.short
    }),
    opacity: 0.5,
    maxWidth: '1rem',
    [theme.breakpoints.up('md')]: {
      maxWidth: '1.25rem'
    }
  },
  '.menu-item.opened &, .menu-item.active &, .menu-item:hover &': {
    img: {
      opacity: 1
    }
  },
  '.menu-item.opened &.tile, .menu-item:hover &.tile': {
    boxShadow: `inset 0 0 0 0.0625rem ${theme.palette.background.grey.alpha.main}`
  },
  '.menu-item.active &.tile': {
    background: theme.palette.action.active
  },
  '.menu-item.opened &.expand': {
    transform: 'rotate(180deg)'
  }
}));
